<template>
  <BaseDialog
      title="htmlプレビュー"
      width="60%"
      :visible.sync="dialogVisible"
      :show-only-close-button="true"
      @close="onClose">
    <template slot="contents">
      <div class="dialog-contents">
        <div id="htmlPreview"
            class="html"
            v-html="htmlPreviewDialogContent" />
      </div>
    </template>
  </BaseDialog>
</template>

<style scoped>
.no-data-message {
  margin: 5px 15px;
}
.dialog-contents .detail-table ::v-deep th,
.dialog-contents .detail-table ::v-deep td {
  padding: 5px 15px;
  font-size: 14px;
  text-align: left;
  vertical-align: top;
}
.dialog-contents .detail-table ::v-deep th {
  min-width: 130px;
}
.dialog-contents .detail-table-list {
  border-top: 1px solid #c7d3d9;
}
.dialog-contents .detail-table-list ::v-deep .el-table {
  box-shadow: initial;
}

.html {
  border-style: solid;
  border-width: thin;
  min-height: 200px;
  max-height: 600px;
  padding: 15px;
  margin: 15px;
  overflow: auto;
}

</style>

<script>
import { mapGetters } from 'vuex'

import * as define from '@/define'
import BaseDialog from '@/components/molecules/BaseDialog'

export default {
  name: 'HtmlPreviewDialog',
  components: {
    BaseDialog
  },
  props: {
    storePath: {
      type: String,
      default: ''
    },
    htmlData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
      getServiceSiteConfig: 'getServiceSiteConfig'
    }),
    htmlPreviewDialogVisible () {
      return (this.$store.state[this.storePath] || {}).htmlPreviewDialogVisible
    },
    htmlPreviewDialogContent () {
      return (this.$store.state[this.storePath] || {}).htmlPreviewDialogContent
    }
  },
  watch: {
    htmlPreviewDialogVisible (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    onClose () {
      this.$store.dispatch({
        type: 'set',
        states: {
          [`${this.storePath}/htmlPreviewDialogVisible`]: false
        }
      })
      // スクロール位置を戻す
      document.getElementById('htmlPreview').scrollTo(0, 0)
    }
  }
}
</script>
